import React from "react";
import Checkbox from "components/Input/Checkbox/Checkbox";
import s from './RolePermissionBlock.module.scss';

const isChecked = (tag, permissionTagList, selectAllList) => {
    if (permissionTagList?.includes(tag) || selectAllList?.includes(tag)) {
        return true;
    }
    return false
}

const RolePermissionBuildingBlock = ({ title, type, callBack, permissionTagList, tag, selectAllList }) => {
    // console.log('tag', tag, 'checked: ', isChecked(tag, permissionTagList, selectAllList))
    return (
        <div className={s.container2}>
            <Checkbox
                key={title}
                name={title}
                oncheckFn={(e) => { callBack(e.target.checked, type, tag) }}
                checked={isChecked(tag, permissionTagList, selectAllList)}
            />
            <div>
                {title}
            </div>
        </div>
    )
}

export default React.memo(RolePermissionBuildingBlock);